import React from "react";

// One icon set for the whole site: stroke icons drawn in currentColor, plus a few solid marks.
const STROKE = {
    pin: ['M12 21.5s7.2-6.2 7.2-11.4a7.2 7.2 0 1 0-14.4 0C4.8 15.3 12 21.5 12 21.5z', 'M12 12.6a2.7 2.7 0 1 0 0-5.4 2.7 2.7 0 0 0 0 5.4z'],
    clock: ['M12 21a9 9 0 1 1 0-18 9 9 0 0 1 0 18z', 'M12 7.2V12l3.4 2'],
    lock: ['M5.8 10.4h12.4v9.8H5.8z', 'M8.7 10.4V7.7a3.3 3.3 0 0 1 6.6 0v2.7'],
    shield: ['M12 2.8l7.4 3.1v5.3c0 4.7-3.1 8.7-7.4 10.3-4.3-1.6-7.4-5.6-7.4-10.3V5.9L12 2.8z', 'M8.9 12.1l2.2 2.2 4-4.3'],
    leaf: ['M20.4 3.6c0 9.3-4.5 14.2-11 14.2-2.6 0-4.5-1.5-4.5-4 0-6.1 6.5-10.2 15.5-10.2z', 'M4.6 20.4C7 14.8 11.3 11 16.8 8.7'],
    cal: ['M4 6.3h16v13.4H4z', 'M8.2 3.3v5', 'M15.8 3.3v5', 'M4 10.6h16'],
    key: ['M20.6 3.6l-8.4 8.4', 'M17.2 7l2.3 2.3', 'M9.4 20.4a4.7 4.7 0 1 0 0-9.4 4.7 4.7 0 0 0 0 9.4z'],
    qr: ['M4 4h6v6H4z', 'M14 4h6v6h-6z', 'M4 14h6v6H4z', 'M14 14h2.6v2.6H14z', 'M17.4 17.4H20V20h-2.6z'],
    wave: ['M2.8 9.4c2-2.1 4-2.1 6 0s4 2.1 6 0 4-2.1 6.4 0', 'M2.8 15.4c2-2.1 4-2.1 6 0s4 2.1 6 0 4-2.1 6.4 0'],
    check: ['M5 12.4l4.6 4.6L19 7.4'],
    chev: ['M6.5 9.5l5.5 5.5 5.5-5.5'],
    arrow: ['M4.5 12h14', 'M13 6.5l5.5 5.5-5.5 5.5'],
    phone: ['M7.3 2.8h9.4v18.4H7.3z', 'M10.6 18.5h2.8'],
    mail: ['M3.4 5.6h17.2v12.8H3.4z', 'M3.9 6.4l8.1 6.1 8.1-6.1'],
    users: ['M9.2 11.6a3.9 3.9 0 1 0 0-7.8 3.9 3.9 0 0 0 0 7.8z', 'M2.6 20.4c0-3.8 3-6.5 6.6-6.5s6.6 2.7 6.6 6.5', 'M16.4 4.3a3.6 3.6 0 0 1 0 7', 'M18 14c2.2.7 3.5 2.4 3.5 5'],
    box: ['M3.6 7.6L12 3.4l8.4 4.2v8.8L12 20.6l-8.4-4.2V7.6z', 'M3.6 7.6L12 11.8l8.4-4.2', 'M12 11.8v8.8'],
    euro: ['M17.4 5.8a6.7 6.7 0 1 0 0 12.4', 'M4.9 10.2h8.3', 'M4.9 13.8h8.3'],
    zap: ['M13.4 2.8L5.6 13.6h5.3l-.8 7.6 8.1-11.2h-5.4l.6-7.2z'],
    vest: ['M8.4 3.2h7.2l2.2 4v13.6H6.2V7.2l2.2-4z', 'M12 3.2v17.6', 'M9.2 8.4h1.4', 'M13.4 8.4h1.4'],
    sun: ['M12 17.2a5.2 5.2 0 1 0 0-10.4 5.2 5.2 0 0 0 0 10.4z', 'M12 1.8v2.4', 'M12 19.8v2.4', 'M4.8 4.8l1.7 1.7', 'M17.5 17.5l1.7 1.7', 'M1.8 12h2.4', 'M19.8 12h2.4', 'M4.8 19.2l1.7-1.7', 'M17.5 6.5l1.7-1.7'],
    home: ['M3.6 10.2L12 3.4l8.4 6.8v9.4H3.6z', 'M9.4 20.6v-6h5.2v6']
};

const FILL = {
    play: ['M8.4 4.8l11 7.2-11 7.2z'],
    star: ['M12 3.2l2.7 5.6 6.2.9-4.5 4.3 1.1 6.1L12 17.2l-5.5 2.9 1.1-6.1-4.5-4.3 6.2-.9z'],
    facebook: ['M13.4 21.9v-8.1h2.7l.4-3.2h-3.1V8.6c0-.9.3-1.6 1.6-1.6h1.6V4.2c-.3 0-1.3-.1-2.4-.1-2.4 0-4 1.5-4 4.1v2.4H7.5v3.2h2.7v8.1z'],
    instagram: ['M12 2.2c-2.7 0-3 0-4.1.1-1.1 0-1.8.2-2.4.5a4.9 4.9 0 0 0-1.8 1.1A4.9 4.9 0 0 0 2.6 5.7c-.2.6-.4 1.3-.5 2.4-.1 1-.1 1.4-.1 4.1s0 3 .1 4.1c.1 1.1.3 1.8.5 2.4.3.7.6 1.3 1.1 1.8.5.5 1.1.9 1.8 1.1.6.2 1.3.4 2.4.5 1 .1 1.4.1 4.1.1s3 0 4.1-.1c1.1-.1 1.8-.3 2.4-.5a4.9 4.9 0 0 0 1.8-1.1c.5-.5.9-1.1 1.1-1.8.2-.6.4-1.3.5-2.4.1-1 .1-1.4.1-4.1s0-3-.1-4.1c-.1-1.1-.3-1.8-.5-2.4a4.9 4.9 0 0 0-1.1-1.8 4.9 4.9 0 0 0-1.8-1.1c-.6-.2-1.3-.4-2.4-.5-1.1-.1-1.4-.1-4.1-.1zm0 1.8c2.7 0 3 0 4 .1.9 0 1.5.2 1.8.3.5.2.8.4 1.1.7.3.3.6.6.7 1.1.1.3.3.9.3 1.8.1 1 .1 1.3.1 4s0 3-.1 4c0 .9-.2 1.5-.3 1.8-.2.5-.4.8-.7 1.1-.3.3-.6.6-1.1.7-.3.1-.9.3-1.8.3-1 .1-1.3.1-4 .1s-3 0-4-.1c-.9 0-1.5-.2-1.8-.3-.5-.2-.8-.4-1.1-.7-.3-.3-.6-.6-.7-1.1-.1-.3-.3-.9-.3-1.8-.1-1-.1-1.3-.1-4s0-3 .1-4c0-.9.2-1.5.3-1.8.2-.5.4-.8.7-1.1.3-.3.6-.6 1.1-.7.3-.1.9-.3 1.8-.3 1-.1 1.3-.1 4-.1zm0 3.1a4.9 4.9 0 1 0 0 9.8 4.9 4.9 0 0 0 0-9.8zm0 8.1a3.2 3.2 0 1 1 0-6.4 3.2 3.2 0 0 1 0 6.4zm6.3-8.3a1.2 1.2 0 1 1-2.3 0 1.2 1.2 0 0 1 2.3 0z'],
    youtube: ['M21.6 7.2c-.2-.9-.9-1.6-1.8-1.8C18.2 5 12 5 12 5s-6.2 0-7.8.4c-.9.2-1.6.9-1.8 1.8C2 8.8 2 12 2 12s0 3.2.4 4.8c.2.9.9 1.6 1.8 1.8 1.6.4 7.8.4 7.8.4s6.2 0 7.8-.4c.9-.2 1.6-.9 1.8-1.8.4-1.6.4-4.8.4-4.8s0-3.2-.4-4.8zM10 15.1V8.9l5.2 3.1z'],
    linkedin: ['M6.9 20.5H3.5V9.4h3.4zM5.2 7.9a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm15.3 12.6h-3.4v-5.4c0-1.3 0-3-1.8-3-1.8 0-2.1 1.4-2.1 2.9v5.5H9.8V9.4h3.3V11h.1c.5-.9 1.6-1.8 3.2-1.8 3.4 0 4.1 2.3 4.1 5.2z'],
    x: ['M17.8 3h3.1l-6.7 7.6 7.9 10.4h-6.2l-4.8-6.3L5.6 21H2.5l7.2-8.2L2.2 3h6.3l4.4 5.8zm-1.1 16.2h1.7L7.4 4.7H5.6z'],
};

const Icon = ({name, size = 20}) => {
    const base = {
        width: size, height: size, viewBox: '0 0 24 24', 'aria-hidden': 'true',
        style: {flex: 'none', display: 'block'}
    };
    if (FILL[name]) {
        return (
            <svg {...base} fill="currentColor">
                {FILL[name].map((d, i) => <path key={i} d={d}/>)}
            </svg>
        );
    }
    return (
        <svg {...base} fill="none" stroke="currentColor" strokeWidth={1.9} strokeLinecap="round" strokeLinejoin="round">
            {(STROKE[name] || []).map((d, i) => <path key={i} d={d}/>)}
        </svg>
    );
};

const STORE_PATHS = {
    ios: 'M16.365 1.43c0 1.14-.47 2.22-1.24 3.01-.83.86-2.17 1.52-3.29 1.43-.14-1.1.44-2.27 1.2-3.04.83-.85 2.28-1.48 3.33-1.4zM20.9 17.1c-.53 1.23-.78 1.78-1.46 2.87-.95 1.52-2.29 3.42-3.95 3.43-1.47.02-1.85-.96-3.85-.95-2 .01-2.42.97-3.9.94-1.66-.03-2.93-1.74-3.88-3.26C1.2 16.2.92 11.2 2.55 8.54c1.16-1.9 3-3.01 4.72-3.01 1.76 0 2.86.97 4.31.97 1.41 0 2.27-.97 4.3-.97 1.54 0 3.17.84 4.33 2.28-3.8 2.08-3.18 7.5.69 9.29z',
    play: 'M4 2.3v19.4c0 .6.65.98 1.17.68l16.3-9.7c.5-.3.5-1.06 0-1.36L5.17 1.62A.8.8 0 0 0 4 2.3z'
};

// App Store / Google Play marks used on the download buttons.
export const StoreGlyph = ({kind}) => (
    <svg width={kind === 'ios' ? 16 : 14} height={17} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"
         style={{flex: 'none'}}>
        <path d={STORE_PATHS[kind]}/>
    </svg>
);

export default Icon;
